import React from "react"

export default function SupportedTerminals({style, userProfile}) {
    if (!userProfile) {
        return null
    }
    return userProfile?.forCosco ? (
        <ul style={style}>
            <li>Seagirt Marine Terminal in Baltimore</li>
            <li>Massport in Boston</li>
            <li>Wando Welch Terminal and North Charleston Terminal in Charleston</li>
            <li>Florida International Terminal in Port Everglades</li>
            <li>Barbours Cut Terminal and Bayport Container Terminal in Houston</li>
            <li>South Florida Container Terminal in Miami</li>
            <li>APM Terminals Mobile, AL in Mobile</li>
            <li>Norfolk International Terminals, Virginia International Terminals and Port of Richmond in Norfolk</li>
            <li>Ports America in New Orleans</li>
            <li>APM Terminals Port Elizabeth, Port Liberty Bayonne, Port Liberty New York and Maher Terminal, Berth 64 in New York</li>
            <li>Ben E. Nutter/ETS, OICT/SSA Terminal and TransBay in Oakland</li>
            <li>Holt Terminal in Philadelphia</li>
            <li>Georgia Ports in Savannah</li>
            <li>SSA Terminal 18, SSA Terminal 30 and SSA Terminal T5 in Seattle</li>
            <li>Pierce County Terminal in Tacoma</li>
            <li>Ports America in Tampa</li>
            <li>Appalachian Regional Port(AARP)/ Crandall</li>
            <li>CSX (Jaxport ICTF) Railroad and Jacksonville Int&apos;l Gateway Terminal in Duval</li>
            <li>Gainesville-Norfolk Southern Railroad - Blue Connector in Hall</li>
            <li>Greer (NS) and Dillon, SC in South Carolina</li>
            <li>Front Royal VIG</li>
        </ul>
    ) : (
        <ul style={style}>
            <li>All terminals in Boston, Baltimore, Charleston, Houston, Miami, Mobile, New Orleans, New York /
                New Jersey, Norfolk, Oakland, Savannah, Seattle, Tacoma and Tampa
            </li>
            <li>All terminals in Long Beach and Los Angeles</li>
            <li>Depot: Duncan and Son Lines, Inc. in Phoenix, AZ</li>
        </ul>
    )
}